import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDatbriks = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-datbriks';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.59 5.647 3.24 8.129v1.746l.001 1.745.765.436c.692.394.759.442.692.49-.04.03-.385.23-.765.444l-.692.39.01 1.753.009 1.753 4.32 2.465c2.551 1.456 4.361 2.466 4.42 2.465.059 0 1.887-1.019 4.42-2.465l4.32-2.464.009-1.754.01-1.753-.692-.39a20 20 0 0 1-.765-.444c-.067-.048 0-.096.692-.49l.765-.436.001-1.745V8.129l-4.361-2.484C14 4.278 12.016 3.161 11.989 3.163S9.982 4.282 7.59 5.647m8.061 1.293 3.587 2.04-.009.894-.009.895-3.61 2.057-3.611 2.057-3.609-2.057-3.61-2.058-.009-.894-.009-.894 3.589-2.047c1.974-1.125 3.617-2.043 3.651-2.04s1.676.925 3.649 2.047M9.17 14.999l2.83 1.61 2.828-1.611c1.555-.886 2.846-1.611 2.87-1.61.023 0 .38.193.792.429l.75.428-.001.887-.001.888-3.585 2.04C13.682 19.182 12.038 20.1 12 20.1s-1.682-.918-3.653-2.04l-3.585-2.04-.001-.888-.001-.887.77-.439c.424-.241.779-.433.79-.428z"
    })
  }));
});
export default SvgDatbriks;